import { useTranslation } from 'react-i18next'
import logo from '../assets/logo-text.svg'

export function Footer() {
  const { t } = useTranslation('footer')

  return (
    <footer className="py-5 md:py-10 flex justify-between items-center m-auto max-w-2xl lg:max-w-inner px-5 lg:px-0">
      <img src={logo} className="h-6 lg:h-8 w-auto" alt="Peakfijn logo" />
      <div className="flex items-center gap-6">
        <nav className="md:space-x-6 flex flex-col md:flex-row">
          <a
            className="text-xs md:text-sm text-neutral-900 hover:text-neutral-800"
            href="https://goo.gl/maps/nWy8Q5RaUe1EsY528"
          >
            {t('city')}
          </a>

          <a
            className="text-xs md:text-sm text-neutral-900 hover:text-neutral-800"
            href={`tel:${t('phoneFormatted')}`}
          >
            {t('phone')}
          </a>
          <a
            className="text-xs md:text-sm text-neutral-900 hover:text-neutral-800"
            href={`mailto:${t('email')}`}
          >
            {t('email')}
          </a>
        </nav>
        <a
          href="https://www.python.org/psf/membership/supporting/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/psf-supporting-member-badge.png"
            className="h-12 w-12"
            alt="PSF Supporting Member"
          />
        </a>
      </div>
    </footer>
  )
}
